import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { getAccentCssVars } from './accent';
import {
  FeaturePromotionBannerActions,
  FeaturePromotionBannerDismissMenu,
} from './atoms/feature-promotion-banner-actions';
import {
  FeaturePromotionBannerBody,
  FeaturePromotionBannerContent,
  FeaturePromotionBannerDescription,
  FeaturePromotionBannerTitle,
} from './atoms/feature-promotion-banner-content';
import { FeaturePromotionBannerHeader } from './atoms/feature-promotion-banner-header';
import {
  FeaturePromotionBannerBullet,
  FeaturePromotionBannerHighlight,
  FeaturePromotionBannerHighlights,
} from './atoms/feature-promotion-banner-highlights';
import { FeaturePromotionBannerMedia } from './atoms/feature-promotion-banner-media';
import { styles } from './feature-promotion-banner.styles';
import type { FeaturePromotionBannerProps } from './feature-promotion-banner.types';

export interface FeaturePromotionBannerComponent extends FC<FeaturePromotionBannerProps> {
  Header: typeof FeaturePromotionBannerHeader;
  Body: typeof FeaturePromotionBannerBody;
  Content: typeof FeaturePromotionBannerContent;
  Title: typeof FeaturePromotionBannerTitle;
  Description: typeof FeaturePromotionBannerDescription;
  Highlights: typeof FeaturePromotionBannerHighlights;
  Highlight: typeof FeaturePromotionBannerHighlight;
  Bullet: typeof FeaturePromotionBannerBullet;
  Actions: typeof FeaturePromotionBannerActions;
  DismissMenu: typeof FeaturePromotionBannerDismissMenu;
  Media: typeof FeaturePromotionBannerMedia;
}

export const FeaturePromotionBanner: FeaturePromotionBannerComponent = ({
  accent = 'seaweed',
  className,
  innerRef,
  testId = 'feature-promotion-banner',
  children,
}) => {
  const accentStyles = getAccentCssVars(accent);

  return (
    <div ref={innerRef} className={cx(styles.container, className)} style={accentStyles} data-testid={testId}>
      {children}
    </div>
  );
};

FeaturePromotionBanner.Header = FeaturePromotionBannerHeader;
FeaturePromotionBanner.Body = FeaturePromotionBannerBody;
FeaturePromotionBanner.Content = FeaturePromotionBannerContent;
FeaturePromotionBanner.Title = FeaturePromotionBannerTitle;
FeaturePromotionBanner.Description = FeaturePromotionBannerDescription;
FeaturePromotionBanner.Highlights = FeaturePromotionBannerHighlights;
FeaturePromotionBanner.Highlight = FeaturePromotionBannerHighlight;
FeaturePromotionBanner.Bullet = FeaturePromotionBannerBullet;
FeaturePromotionBanner.Actions = FeaturePromotionBannerActions;
FeaturePromotionBanner.DismissMenu = FeaturePromotionBannerDismissMenu;
FeaturePromotionBanner.Media = FeaturePromotionBannerMedia;
